/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CommonModule } from "@angular/common";
import { Component, computed, inject, input, output } from "@angular/core";
import { NameTag } from "../../../name-tag/name-tag.component";
import { SelectStore } from "../../select.store";

@Component({
    selector: "app-multiple-select-selected-item",
    templateUrl: "./multiple-select-selected-item.component.html",
    imports: [NameTag, CommonModule],
})
export class MultipleSelectSelectedItem {
    readonly selectStore = inject(SelectStore);

    options = input.required<any[]>();
    value = input<string>();
    bindLabel = input.required<string>();
    bindValue = input.required<string>();

    remove = output<void>();

    current = computed(() =>
        this.options().find(
            (option) => option[this.bindValue()!] === this.value(),
        ),
    );

    currentLabel = computed(() => this.current()?.[this.bindLabel()!]);
}
